import script from "./InputTag.vue?vue&type=script&setup=true&lang=js"
export * from "./InputTag.vue?vue&type=script&setup=true&lang=js"

import "./InputTag.vue?vue&type=style&index=0&id=1cd4c19c&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1cd4c19c"]])

export default __exports__